import { LOADING_DATA_CAL_MOB, LOADING_DATA_MOB, LOADING_DATA_MTO_MOB, LOADING_SOL_CORR_ACTIVO, 
    POST_EDITPROGCAL_ACTIVO, POST_EDITPROGMTO_MOB, POST_MTOCORRECTIVO_ACTIVO, POST_SOLICITUD_MTO_ACTIVO, SET_CALIBRACIONES_ACTIVO, SET_MOBILIARIO,
     SET_MOBILIARIOS, SET_MTOCORR_ACTIVO, SET_MTOPREV_ACTIVO, SET_MTOSCORRECTIVOS_ACTIVO, SET_MTOSPREV_ACTIVO, SET_PROGCALS_ACTIVO,  SET_PROGMTOS_MOB, 
     SET_SOL_CORR_ACTIVO } from '../types';

const initialState={
    loadingdata:true,
    loadingmto:true,
    loadingcal:true,
    loadingsolcorr:true,
    mobiliarios:[],
    mobiliario:{},
    calibracionesmob:{},
    progracalmobiliario:[],
    progcalsmobiliario:[],
    programtomobiliario:[],
    progmtosmobiliario:[],
    solicitudcorrmobiliario:[],
    solicitudescorrmobiliario:[],
    mtomobiliario:{},
    mtosmobiliario:[],
    mtocorrectivomobiliario:{},
    mtoscorrectivosmobiliario:[],
    solicitudesmtomobiliario:[],
    }


    export default function (state=initialState,action){
        switch(action.type){
            case LOADING_DATA_MOB:
                return {
                    ...state,
                    loadingdata:true
                }
            case LOADING_DATA_MTO_MOB:
                    return {
                        ...state,
                        loadingmto:true
                    }

            case LOADING_DATA_CAL_MOB:
                    return {
                        ...state,
                            loadingcal:true
                    }

        case LOADING_SOL_CORR_ACTIVO:
                    return{
                        ...state,
                        loadingsolcorr:true
                    }

            case SET_MOBILIARIOS:
                    return{
                        ...state,
                        mobiliarios:action.payload,
                        loadingdata:false,
                     
                    }
            case SET_PROGMTOS_MOB:
                return{
                    ...state,
                    progmtosmobiliario:action.payload,
                    loadingmto:false
                }
            case SET_PROGCALS_ACTIVO:
                return{
                    ...state,
                    progcalsmobiliario:action.payload,
                    loadingcal:false,
                }

             case SET_SOL_CORR_ACTIVO:
                return{
                    ...state,
                    loadingsolcorr:false,
                    solicitudescorrmobiliario:action.payload
                }
            case SET_MOBILIARIO:
                    return{
                        ...state,
                        mobiliario:action.payload,
                        loadingdata:false,
                         
                    }
            case SET_MTOSPREV_ACTIVO:
                return{
                    ...state,
                    mtosmobiliario:action.payload,
                    loadingmto:false
                }
            case SET_MTOPREV_ACTIVO:
                return{
                    ...state,
                    mtomobiliario:action.payload,
                    loadingdata:false
                }
            case SET_MTOCORR_ACTIVO:
                return{
                    ...state,
                    mtocorrectivomobiliario:action.payload,
                    loadingdata:false
                }
            case POST_EDITPROGMTO_MOB:
                       return{
                        ...state,
                        programtomobiliario:[action.payload,...state.programtomobiliario]
                       }
              
                case POST_SOLICITUD_MTO_ACTIVO:
                    return{
                        ...state,
                        solicitudesmtomobiliario:[action.payload,...state.solicitudesmtomobiliario]
                    }

        case POST_EDITPROGCAL_ACTIVO:
                    return{
                        ...state,
                        progcalsmobiliario:[action.payload,...state.progracals]
                    }

        case SET_CALIBRACIONES_ACTIVO:
            return{
                ...state,
                calibracionesmob:action.payload,
                loadingcal:false

            }

        case POST_MTOCORRECTIVO_ACTIVO:
                    return {
                        ...state,
                        mtocorrectivomobiliario:[action.payload,...state.mtocorrectivomobiliario]
                    }
         case SET_MTOSCORRECTIVOS_ACTIVO:
                    return {
                        ...state,
                        mtoscorrectivosmobiliario:action.payload,
                        loadingmto:false
                    }
            default:
                return{
                    ...state
                }
        
        }
     
    }

               
            